module.exports = __webpack_public_path__ + "img/rebecca-on-jungle-01.65065480.jpg";